import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, patient, isDeleting }) => {
  if (!isOpen) return null;

  // ESC key handler to close modal
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event?.key === 'Escape' && isOpen && !isDeleting) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, isDeleting, onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card rounded-xl shadow-2xl border border-border w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-destructive/10 mb-4">
            <Icon name="AlertTriangle" size={24} className="text-destructive" />
          </div>

          <h2 className="text-xl font-semibold text-foreground mb-2">
            Excluir Paciente
          </h2>

          {/* Patient name display box */}
          <div className="bg-muted/50 border border-border rounded-lg p-3 mb-3">
            <p className="text-sm font-medium text-foreground text-center">
              {patient?.full_name || patient?.name}
            </p>
          </div>

          <p className="text-sm text-muted-foreground mb-4">
            Tem certeza que deseja excluir este paciente? Esta ação não pode ser desfeita e todos os dados do paciente serão permanentemente removidos.
          </p>

          <div className="bg-warning/10 border border-warning/20 rounded-lg p-3 mb-6">
            <div className="flex gap-2">
              <Icon name="Info" size={16} className="text-warning flex-shrink-0 mt-0.5" />
              <p className="text-xs text-warning">
                O histórico de consultas e informações de contato serão perdidos permanentemente.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isDeleting}
              fullWidth
            >
              Retornar
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isDeleting}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Excluir Paciente
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;